/**
* Book CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'book-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      CustomEase.create( 'fastForwardBookCTA', 'M0,0,C0.266,0.412,0.451,0.545,0.58,0.666,0.612,0.696,0.753,0.829,0.87,0.914,0.928,0.956,0.942,1,1,1 ' );

      const sections = gsap.utils.toArray( '.book-cta' );

      sections.forEach( ( section ) => {
        const topYellowLine = section.querySelector( '.top-lines .yellow-line' );
        const topGreenLine = section.querySelector( '.top-lines .green-line' );
        const bottomYellowLine = section.querySelector( '.bottom-lines .yellow-line' );
        const bottomGreenLine = section.querySelector( '.bottom-lines .green-line' );

        gsap
            .timeline( {
              scrollTrigger: {
                trigger: section,
                start: 'top 60%',
                scrub: false,
              },
            } )
            .from( topYellowLine, {x: '-100vw', ease: 'fastForwardBookCTA', lazy: false}, 0 )
            .from( topGreenLine, {x: '-100vw', ease: 'fastForwardBookCTA', lazy: false}, 0.25 )
            .from( bottomYellowLine, {x: '-100vw', ease: 'fastForwardBookCTA', lazy: false}, 0 )
            .from( bottomGreenLine, {x: '-100vw', ease: 'fastForwardBookCTA', lazy: false}, 0.25 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'book-cta', COMPONENT );
} )( app );
